import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';

export default function ToggleNav() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const toggleNav = useCallback(() => {
    setNavOpen((prev) => {
      const next = !prev;
      document.documentElement.classList.toggle('nav_open', next);
      return next;
    });
  }, []);

  const closeNav = useCallback(() => {
    setNavOpen(false);
    document.documentElement.classList.remove('nav_open');
  }, []);

  const toggleTopbar = useCallback(() => {
    document.documentElement.classList.toggle('topbar_open');
  }, []);

  const toggleSidebarMinimize = useCallback(() => {
    const wrapper = document.querySelector('.wrapper');
    if (wrapper) {
      wrapper.classList.toggle('sidebar_minimize');
    }
  }, []);

  // Tutup drawer saat pindah route
  useEffect(() => {
    setNavOpen(false);
    document.documentElement.classList.remove('nav_open');
  }, [location]);

  // Cleanup saat komponen unmount
  useEffect(() => {
    return () => {
      document.documentElement.classList.remove('nav_open');
    };
  }, []);

  return (
    <>
      <button
        className="navbar-toggler sidenav-toggler ml-auto"
        type="button"
        onClick={toggleNav}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon">
          <i className="icon-menu" />
        </span>
      </button>
      <button className="topbar-toggler more" onClick={toggleTopbar}>
        <i className="icon-options-vertical" />
      </button>
      <div className="nav-toggle">
        <button className="btn btn-toggle toggle-sidebar" onClick={toggleSidebarMinimize}>
          <i className="icon-menu" />
        </button>
      </div>
      {navOpen &&
        createPortal(
          <div className="sidebar-overlay" onClick={closeNav} />,
          document.body
        )}
    </>
  );
}
